module.exports = __webpack_public_path__ + "assets/img/lightSensorColor.6c5e2102.png";